define(["dojo-proxy-loader?name=dojo/_base/kernel!/home/mcdeploy/mc_node_modules_cache/aba3733e3c8f70b37f672f878a7280e3f754dbd1/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "./text"], function (dojo) {
  // module:
  //		dojo/cache

  // dojo.cache is defined in dojo/text
  return dojo.cache;
});